export default __webpack_public_path__ + "static/media/Aura-Egg__29.b31276b9.png";